// A tiny hook: is the window narrower than a phone-ish breakpoint? Used to turn the sidebar into a slide-over drawer.
import { useEffect, useState } from 'react';

export const NARROW_PX = 760;

export const useNarrow = (): boolean => {
  const read = (): boolean => (typeof window === 'undefined' ? false : window.innerWidth < NARROW_PX);
  const [narrow, setNarrow] = useState(read);

  useEffect(() => {
    const onResize = (): void => setNarrow(read());

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return narrow;
};
